export const UTILITY_FIELDS = ["termsOfService"];

/**
 *
 * @param {{text: string}} child
 * @returns
 */
export function isFieldRequired(child) {
  return child.required || child.text?.toLowerCase().includes("(required)");
}

/**
 *
 * @param {{text: string}} child
 * @returns
 */
export function getErrorMessage(child) {
  const fieldName = child.text?.split("(")[0].toLowerCase().trim();
  return `Please provide your ${fieldName}.`;
}
/**
 *
 * @param {{children: [Record<string, any>]} data
 * @returns
 */
export function extractFormFields(data = {}) {
  return (
    data.children
      ?.map((child) => {
        if (child.role === "editableText") {
          return {
            id: `input-${child.id}`, // fix uuid-based id that starts with a number
            type: "text",
            name: child.id,
            label: child.text,
            defaultValue: child.value || "",
            maxlength: child.maxlength,
            shouldAnimate: !!child.value,
            isValidValue: !!child.value,
            required: isFieldRequired(child),
            errorMessage: getErrorMessage(child)
          };
        } else if (child.role === "select") {
          return {
            id: `select-${child.id}`, // fix uuid-based id that starts with a number
            type: "radio-group",
            name: child.id,
            label: child.text,
            defaultValue: child.value,
            options: child.children.map((opt) => ({
              id: `radio-${opt.id}`,
              name: child.id,
              label: opt.text,
              value: opt.value
            })),
            required: isFieldRequired(child),
            errorMessage: getErrorMessage(child)
          };
        } else if (child.role === "selectMenu") {
          // in the template, the select menu is paired with a select button that holds the value of the field, so we need to find it to get the default value and name of the field
          const fieldHolder = data.children?.find(
            (c) => c.role === "selectButton" && c.targetViewID === child.id
          );
          return {
            id: `select-${fieldHolder.id}`, // fix uuid-based id that starts with a number
            type: "radio-group",
            name: fieldHolder?.id,
            label: fieldHolder.name,
            defaultValue: fieldHolder?.value,
            options: child.children.map((opt) => ({
              id: `radio-${opt.id}`,
              name: child.id,
              label: opt.text,
              value: opt.id
            })),
            required: isFieldRequired(child),
            errorMessage: getErrorMessage(child)
          };
        } else if (child.role === "checkbox") {
          return {
            id: `checkbox-${child.id}`, // fix uuid-based id that starts with a number
            type: "checkbox",
            name: child.id,
            label: child.text,
            isChecked: child.value,
            required: isFieldRequired(child),
            errorMessage: getErrorMessage(child)
          };
        } else if (child.role === "button") {
          return {
            id: `button-${child.id}`, // fix uuid-based id that starts with a number
            type: "submit",
            label: child.text
          };
        }
      })
      .filter(Boolean) ?? []
  );
}
